export const viuGoTrendClass = (trend) => {
    if (trend === "increased") return "kbv-odds-value--up";
    if (trend === "decreased") return "kbv-odds-value--down";
    return "";
};

